import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { DefaultButton, DefaultCard } from 'design-system';
import IndividualPriceDetail from 'src/components/screens/components/IndividualPriceDetail';
import BodyResumeCard from './BodyResumeCard';
import { CardIndividualProps } from './CardIndividual';

type Props = CardIndividualProps & {
  forceCollapsed?: boolean;
  onForceCollapsedUpdate?: () => void;
  openDialog?: boolean;
  onSelected: (packageId: number, forceNext: boolean) => void;
};

const CreatedQuotationResumeCard = ({
  coverageCatalogResumes,
  coverageCatalogs,
  moneyType,
  packageOption,
  unit,
  forceCollapsed,
  onForceCollapsedUpdate,
  quotation,
  openDialog,
  onSelected,
}: Props): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <DefaultCard
      data-testid="created-quotation-resume-card"
      title=""
      nonCollapsibleElement={
        <Box>
          <IndividualPriceDetail
            data-testid="individual-price-detail"
            anualPrice={unit.total.grandTotal}
            moneyType={moneyType}
            packageOption={packageOption}
            openDialog={openDialog}
            isInspection={isMobile}
            createdAt={quotation.createdAt}
          />
          <Box sx={{ marginY: 2 }}>
            <DefaultButton
              data-testid="comprar-button"
              fullWidth
              onClick={() => onSelected(unit.package.id, true)}
            >
              Comprar
            </DefaultButton>
          </Box>
        </Box>
      }
      collapsible={isMobile}
      forceCollapsed={forceCollapsed}
      onForceCollapsedUpdate={onForceCollapsedUpdate}
    >
      <BodyResumeCard
        coverageCatalogResumes={coverageCatalogResumes}
        coverageCatalogs={coverageCatalogs}
        moneyType={quotation.quotationProfile.typeOfMoney}
        packageOption={packageOption}
        unit={unit}
        quotation={quotation}
      />
    </DefaultCard>
  );
};

export default CreatedQuotationResumeCard;
